<div class="options-wrapper scroll-style">
  @if (hasData) {
    <div
      class="risk-reward"
      >
      <div class="risk-reward-top row">
        <div class="risk-reward-top-left">
          <div class="buy-put-text">
            BUY
            <div [ngClass]="options$.value[0]?.type ? options$.value[0]?.type : options$.value[1]?.type">
              {{
              options$.value[0]?.type ? options$.value[0]?.type.toUpperCase() : options$.value[1]?.type.toUpperCase()
              }}
            </div>
          </div>
          <div class="expiry">
            <small>Expiration:</small>
            {{
            options$.value[0]?.expiration_date ? options$.value[0]?.expiration_date : options$.value[1]?.expiration_date
            }}
          </div>
          <div class="dte">DTE: {{ options$.value[0]?.dte ? options$.value[0]?.dte : options$.value[1]?.dte }} days</div>
        </div>
        @if (warnings.length) {
          <div
            class="warning-message"
            >
            @if (warnings.length === 1) {
              {{ warnings[0] }}
            } @else {
              <ul>
                @for (warning of warnings; track warning) {
                  <li>{{ warning }}</li>
                }
              </ul>
            }
          </div>
        }
      </div>
      <div class="row">
        <app-option-record
          [option]="options$.value[0]"
          [otherOption]="options$.value[1]"
          [tradingStrategy]="firstTradingStrategy"
          [accountRiskAmount]="accountRiskAmount"
          [isOptionGreeks]="isOptionGreeks"
          [ngStyle]="{ flex: !options$.value[0]?.itm || !options$.value[0]?.atm ? '0 0 25%' : '0 0 50%' }"
          [placeOrderCanBeShown]="showPlaceOrderButtons"
          [symbol]="symbol"
          [isPrint]="isPrint"
          >
        </app-option-record>
        <app-option-record
          [option]="options$.value[1]"
          [otherOption]="options$.value[0]"
          [tradingStrategy]="secondTradingStrategy"
          [accountRiskAmount]="accountRiskAmount"
          [isOptionGreeks]="isOptionGreeks"
          [ngStyle]="{ flex: !options$.value[1]?.itm || !options$.value[1]?.atm ? '0 0 25%' : '0 0 50%' }"
          [placeOrderCanBeShown]="showPlaceOrderButtons"
          [symbol]="symbol"
          [isPrint]="isPrint"
          >
        </app-option-record>
      </div>
      <div
        (click)="toggleOptionGreeks()"
        class="hide-option-greeks"
        >
        @if (isOptionGreeks) {
          <span>Hide Option Greeks</span>
        }
        @if (!isOptionGreeks) {
          <span>Show Option Greeks</span>
        }
      </div>
    </div>
  } @else {
    @if (!isLoading) {
      <div
        class="no-data s2"
        >
        No options fit our trading criteria for this stock.
      </div>
    }
  }
</div>
